module.exports = __webpack_public_path__ + "img/26.87b330b1.png";